<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import AudioButton from "@/components/AudioButton.vue";
import type { GyldendalPronunciationVariant } from "@/types/article-formats/gyldendal";

const props = defineProps<{
  items: GyldendalPronunciationVariant[];
}>();

const itemsWithPronunciationFile = computed<GyldendalPronunciationVariant[]>(() =>
  props.items.filter((item) => item.soundFile)
);

const { t } = useI18n();
</script>

<template>
  <template v-for="item in itemsWithPronunciationFile" :key="item">
    <span>
      <span v-if="item.langVariant">
        {{ item.langVariant }}
      </span>
      <span v-if="item.productiveDescription">
        {{ item.productiveDescription }}
      </span>
    </span>

    <span>
      <AudioButton
        v-if="item.soundFile"
        :audio-url="item.soundFile"
        :aria-label="t('article.pronunciation.label')"
        variant="negative"
      />
      <span v-if="item.pronunciation" class="mx-1"> [{{ item.pronunciation }}] </span>
    </span>
  </template>
</template>
